import { createContext } from 'react';

import type { InteractionMode } from '../../interactions-overlay/types.js';

export interface ChartToolbarContextProps {
  /** Updates the last item selected in the toolbar. */
  updateLastItemSelected: (state: InteractionMode | undefined) => void;
  /** Indicates that controls are inside a dropdown menu. */
  isMenuElement?: boolean;
  /** Indicates that the toolbar is currently expanded. */
  isExpanded?: boolean;
  /** The last interaction mode selected in the toolbar. */
  lastItemSelected?: InteractionMode;
  /** Indicates if the toolbar was dragged. */
  didDrag?: boolean;
  /** Resets the didDrag state to false. */
  resetDidDrag?: () => void;
}

export const ChartToolbarContext = createContext<ChartToolbarContextProps>({
  isMenuElement: false,
  isExpanded: true,
  lastItemSelected: undefined,
  didDrag: false,
  updateLastItemSelected: (state: InteractionMode | undefined) => {
    return;
  },
});

ChartToolbarContext['displayName'] = 'ToolbarContext';
